const configInitialState = {
    config: {
        loading: false,
        error: null,
        data: null
    },
};

export default configInitialState;